import { render, staticRenderFns } from "./KnifeIcon.vue?vue&type=template&id=0b808264"
import script from "./KnifeIcon.vue?vue&type=script&lang=js"
export * from "./KnifeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports